import axios from 'axios';
import {QueryClient} from "react-query";

/*** --- APP SETTINGS --- ***/
export const APP_NAME = 'famr_portal';
export const BASE_API_URL = process.env.NODE_ENV === 'production' ? 'https://portal-api.famr.us' : 'http://localhost:1337'
axios.defaults.baseURL = BASE_API_URL;

/*** --- PERMISSIONS SETTINGS --- ***/
export const ROLES = {
    CLIENT: "Client",
    ADMIN: "Administrator",
    SALES: "Sales",
    CLIENT_PREFERRED: "Client Preferred"
}

/*** --- UI SETTINGS --- ***/
export const TOAST_DURATION = 10;
export const ERROR_TOAST_DURATION = 20;
export const APPLICATION_DISPLAY_NAME = 'FAMR Portal'


/*** --- LOCAL STORAGE SETTINGS --- ***/
export const LOCAL_STORAGE = {
    SIDEBAR_LS_KEY: getLocalStorageKey('sidebar_collapsed'),
}

export function getLocalStorageKey(key) {
    return `${APP_NAME}_${key}`;
}


/*** --- REACT QUERY SETTINGS --- ***/
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        }
    }
})

/*** --- AUTH0 SETTINGS --- ***/
export const AUTH0_DOMAIN = process.env.NODE_ENV === 'production' ? "auth.famr.us" : "dev-3jfina5d.us.auth0.com";
export const AUTH0_CLIENT_ID = process.env.NODE_ENV === 'production' ? "vLOp1k2zZZQbLyJjGFff8ofqZAshSIqC" : "Sp1k8QelBmy2hzf82qFdobyE3jrBZldk";
export const AUTH0_REDIRECT_URI = process.env.NODE_ENV === 'production' ? "https://app.famr.us" : "http://localhost:3000";
export const AUTH0_AUDIENCE = "https://famr.us";
